module.exports = __webpack_public_path__ + "resources/bc38dd4b6e9dc17acab41f4672092fd4.png";


//////////////////
// WEBPACK FOOTER
// ./resources/card-templates/oversizedcrisishero.png
// module id = 217
// module chunks = 0